function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { useEffect } from "react";
import { unmountComponentAtNode, render } from "react-dom";
import InfoIcon from "../icon/info";
import ErrorIcon from "../icon/error";
import { STYLE_PREFIX } from "../const";
import "./style.less";
var Message = function Message(_ref) {
  var content = _ref.content,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? "info" : _ref$type,
    onClose = _ref.onClose;
  useEffect(function () {
    var t = setTimeout(onClose, 3000);
    return function () {
      t && clearTimeout(t);
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "custom-message")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "custom-message_item")
  }, type === 'error' ? /*#__PURE__*/React.createElement(ErrorIcon, null) : /*#__PURE__*/React.createElement(InfoIcon, null), /*#__PURE__*/React.createElement("label", {
    className: "".concat(STYLE_PREFIX, "custom-message_content")
  }, content)));
};
var getContainer = function getContainer() {
  var container = document.querySelector(".".concat(STYLE_PREFIX, "custom-message-wrapper"));
  if (!container) {
    var _container = document.createElement("div");
    _container.className = "".concat(STYLE_PREFIX, "custom-message-wrapper");
    document.body.appendChild(_container);
    return _container;
  }
  return container;
};
var _message = function _message(type) {
  return function (props) {
    var container = getContainer();
    var _dom = document.createElement("div");
    container.appendChild(_dom);
    var hanldeClose = function hanldeClose() {
      unmountComponentAtNode(_dom);
      container.removeChild(_dom);
    };
    render( /*#__PURE__*/React.createElement(Message, _extends({}, props, {
      type: type,
      onClose: hanldeClose
    })), _dom);
  };
};
var info = _message("info");
var error = _message("error");
export default {
  info: info,
  error: error
};